// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCypiK6JZP3t5Q87-tNRKvqVFFLhBAoC0E',
    authDomain: 'spaq-156518.firebaseapp.com',
    databaseURL: 'https://spaq-156518.firebaseio.com',
    projectId: 'spaq-156518',
    storageBucket: 'spaq-156518.appspot.com',
    messagingSenderId: '187946032825',
  },
};



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/environments/environment.ts